import { makeStyles, Hidden } from "@material-ui/core";
import TagNewPicto from "ui/StateTag/assets/new-desktop-i.svg";
import TagNewPictoSmall from "ui/StateTag/assets/new-mobile-i.svg";
import TagSecondHandInfoPictoSmall from "ui/StateTag/assets/reco-tag-mobile-i.svg";
import TagSecondHandInfoPicto from "ui/StateTag/assets/reco-tag-desktop-i.svg";
import InformationDrawer from "components/design-system/molecules/InformationDrawer";
import DurableNewDrawerContent from "components/product/DurableNew/DurableNewDrawerContent";
import SecondHandDrawerContent from "components/product/SecondHand/SecondHandDrawerContent";

export const ProductStateTagWithInfo = ({ isStateNew }) => {
  const classes = useStyle();

  const config = isStateNew
    ? {
        title: "Neuf durable, du neuf qui dure !",
        mobileIcon: TagNewPictoSmall,
        desktopIcon: TagNewPicto,
        drawer: DurableNewDrawerContent,
      }
    : {
        title: "Reconditionné en France et responsable !",
        mobileIcon: TagSecondHandInfoPictoSmall,
        desktopIcon: TagSecondHandInfoPicto,
        drawer: SecondHandDrawerContent,
      };

  const renderDrawer = (width: string, Icon: React.ComponentType<any>) => (
    <InformationDrawer
      anchor="right"
      width={width}
      title={config.title}
      button={<Icon className={classes.tagContainer} />}
    >
      {() => <config.drawer />}
    </InformationDrawer>
  );

  return (
    <>
      <Hidden implementation="css" mdUp>
        {renderDrawer("100%", config.mobileIcon)}
      </Hidden>
      <Hidden implementation="css" smDown>
        {renderDrawer("470px", config.desktopIcon)}
      </Hidden>
    </>
  );
};

const useStyle = makeStyles(() => ({
  tagContainer: {
    display: "flex",
    position: "relative",
    zIndex: 1,
  },
}));
